module.exports = __webpack_public_path__ + "static/sd-international-fc-fa1cd5e5c5c499e7dfccc52b5b2b9a0a.png";